import { useEffect, useState } from 'preact/hooks';
import { platformAudit, PlatformUserSummary, AuditRow } from './api';

interface Props {
  user: PlatformUserSummary;
}

export function HomePage({ user }: Props) {
  const [rows, setRows] = useState<AuditRow[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    platformAudit
      .query({ platformUserId: user.id, limit: 10 })
      .then((r) => setRows(r.rows))
      .catch((e) => setErr(describeError(e)));
  }, [user.id]);

  return (
    <div>
      <h1 style={{ margin: '0 0 4px 0' }}>Welcome, {user.name}</h1>
      <p style={{ color: 'var(--admin-text-dim)', marginTop: 0 }}>
        You are signed in as <code>{user.username}</code> with role{' '}
        <code>{user.role}</code>.{' '}
        {user.lastLoginAt && <>Last login: {new Date(user.lastLoginAt).toLocaleString()}.</>}
      </p>

      <section style={{ marginTop: 32 }}>
        <h2>Recent activity (you)</h2>
        {err && <div class="error-banner">{err}</div>}
        {rows === null && <p>Loading…</p>}
        {rows && rows.length === 0 && (
          <p style={{ color: 'var(--admin-text-dim)' }}>No audit rows yet.</p>
        )}
        {rows && rows.length > 0 && (
          <table class="admin-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Target</th>
                <th>Status</th>
                <th>From IP</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td class="mono">{formatTime(r.occurredAt)}</td>
                  <td class="mono">{r.action}</td>
                  <td class="mono">
                    {r.targetKind && (
                      <>
                        {r.targetKind}
                        {r.targetId && <>: {truncate(r.targetId, 20)}</>}
                      </>
                    )}
                  </td>
                  <td>
                    <span class={`badge ${r.success ? 'success' : 'failure'}`}>
                      {r.success ? 'ok' : 'fail'}
                    </span>
                  </td>
                  <td class="mono">{r.requestIp || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </section>
    </div>
  );
}

function formatTime(t: string): string {
  try {
    const d = new Date(t);
    return d.toLocaleString();
  } catch {
    return t;
  }
}

function truncate(s: string, n: number): string {
  return s.length > n ? s.slice(0, n) + '…' : s;
}

function describeError(err: unknown): string {
  if (err instanceof Error) return err.message;
  return 'Unknown error';
}
